export class TimelineEvent {
  Index: number;
  Icon: string | null;
  HoldOn: boolean;
  Status: string | null;
  Title: string | null;
  Description: string | null;
}